/**
 * Live default for the (migrated) beat-options group. Read by `app/lib/undoRedoListener.tsx`
 * and by the `beats`, `ecg-events` and `hr-summary` widgets' `summaryFunction`.
 */
// eslint-disable-next-line import/prefer-default-export -- named import at every call site
export const defaultBeatsOptions = {
  beatChangesState: [] as any[],
  resetBulkBeatsChangesState: [] as any[],
  bulkBeatsChangesState: [] as any[],
  swapBeatChangesState: [] as any[],
  bulkSwapBeatsState: [] as any[],
  resetSwapBeatsState: [] as any[],
  bulkReviewedBeatsState: [] as any[],
  resetBulkReviewedBeatsState: [] as any[],
  reviewedBeatsChangesState: [] as any[],
};
